<template>
  <swiper :options="swiperOption" class="responsibility-swiper">
    <swiper-slide
      v-for="(item, idx) in imgList"
      :key="idx"
      class="responsibility-swiper-item"
    >
      <img :src="item.url" />
    </swiper-slide>
  </swiper>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper"; //局部引入

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      imgList: [
        {
          url: require("@/assets/responsibility/responsibility-zero.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-two.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-three.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-four.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-five.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-six.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-seven.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-eight.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-nine.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-ten.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-element.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-twolf.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-thriten.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-fourten.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-fiveten.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-sixten.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-seventen.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-element.png"),
        },
        {
          url: require("@/assets/responsibility/responsibility-nineten.png"),
        },
      ],
      swiperOption: {
        // autoplay: true,
        speed: 5000, //每个轮播图过渡的时间
        delay: 5000, //每个轮播图间隔
        // spaceBetween:20,
        slidesPerView: 'auto', //slide间距
        // slidesPerView: 'auto', //当前页面显示几个，这里是auto
        loop: true, // 循环模式选项
        autoplay: {
          delay: 0,
          // stopOnLastSlide: false,
          disableOnInteraction: true,
        },
      },
    };
  },
};
</script>
 
<style lang='scss' scoped>
.responsibility-swiper {
  width: 1098px;
  height: 299px;
  border-radius: 0.1rem;
  overflow: hidden;
  transition-timing-function: linear;
  ::v-deep .swiper-wrapper {
    transition-timing-function: linear;
  }
}
.responsibility-swiper-item {
  width: 169px;
  height: 299px;
  margin-right: 40px;
  img {
    width: 169px;
    height: 299px;
   
  }
}
</style>